document.addEventListener("DOMContentLoaded", function () {
console.log("aaaaa");
const pdp_faqButtons = document.querySelectorAll(".faq-question");
  pdp_faqButtons.forEach((button, index) => {
    const answers = button.nextElementSibling;
    button.addEventListener("click", () => {
        console.log("asdasdasd");
      const isActive_pdp = button.classList.contains("active");

      // Collapse all other FAQs
      pdp_faqButtons.forEach((otherButton) => {
        const otherAnswers = otherButton.nextElementSibling;
        otherButton.classList.remove("active");
        otherButton.setAttribute("aria-expanded", "false");
        if (otherAnswers) {
          otherAnswers.style.maxHeight = null;
        }
      });

      // Toggle clicked FAQ
      if (!isActive_pdp) {
        button.classList.add("active");
        button.setAttribute("aria-expanded", "true");
        if (answers) {
          answers.style.maxHeight = answers.scrollHeight + "px";
        }
      } else {
        button.classList.remove("active");
        button.setAttribute("aria-expanded", "false");
        if (answers) {
          answers.style.maxHeight = null;
        }
      }
    });


    // ✅ Open the first FAQ on load
    const faqSection = document.querySelector(".pdp-faq"); // Check if .pdp-faq section exists
  if (faqSection) {
    if (index === 0) {
      button.classList.add("active");
      button.setAttribute("aria-expanded", "true");
      const answer = button.nextElementSibling;
      if (answer) {
        answer.style.maxHeight = answer.scrollHeight + "px";
      }
    }
  }

  });
});






// document.addEventListener("DOMContentLoaded", function () {
//   const orderButtons = document.querySelectorAll(".order-btn");
//   const target = document.querySelector(".product__description");

//   if (!target) return;

//   orderButtons.forEach(button => {
//     button.addEventListener("click", function (e) {
//       e.preventDefault();

//       if (!isElementInViewport(target)) {
//         target.scrollIntoView({ behavior: "smooth", block: "start" });
//       }
//     });
//   });
// });

// // Helper function to check if element is in viewport
// function isElementInViewport(el) {
//   const rect = el.getBoundingClientRect();
//   return (
//     rect.top >= 0 &&
//     rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
//   );
// }
document.addEventListener("DOMContentLoaded", function () {
  const orderButtons = document.querySelectorAll(".order-btn");
  const target = document.querySelector(".product__description");
  const headerHeight = 100; // Adjust this to your fixed header height in pixels

  if (!target) return;

  orderButtons.forEach(button => {
    button.addEventListener("click", function (e) {
      e.preventDefault();

      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const targetRect = target.getBoundingClientRect();
      const targetHeight = target.offsetHeight;

      // Calculate the adjusted height (description height minus header height), clamp to 0 minimum
      const adjustedHeight = Math.max(targetHeight - headerHeight, 0);
      console.log(adjustedHeight + "heightss");

      // Position of the top of the element relative to the document
      const targetTopPageY = targetRect.top + window.pageYOffset;

      // Position of the bottom of the element relative to the document
      const targetBottomPageY = targetTopPageY + targetHeight;

      // Current scroll position from top of page
      const currentScroll = window.pageYOffset;

      // Bottom of viewport relative to the page
      const viewportBottom = currentScroll + viewportHeight;

      let scrollTo;

      if (targetHeight <= (viewportHeight - headerHeight)) {
        // The whole description fits in viewport below header,
        // scroll top of description just below header
        scrollTo = targetTopPageY - headerHeight + adjustedHeight + 100;
        console.log(scrollTo + " scrollTop when description fits viewport");
      } else {
        // Description taller than visible space:
        // Check if bottom is visible; if not, scroll to make bottom visible below header
        if (targetBottomPageY > viewportBottom) {
          scrollTo = targetBottomPageY - viewportHeight + headerHeight;
          console.log(scrollTo + " scrollTop to show bottom");
        } else {
          // Already fully visible, just scroll to top minus header
          scrollTo = targetTopPageY - headerHeight;
          console.log(scrollTo + " scrollTop, already visible");
        }
      }

      // Prevent negative scroll values
      scrollTo = Math.max(scrollTo, 0);

      window.scrollTo({
        top: scrollTo,
        behavior: "smooth"
      });

      console.log("Adjusted description height:", adjustedHeight);
      console.log("Final scroll position:", scrollTo);
    });
  });
});
